module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter-One.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-20"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }), _vm._v("CHAPTER ONE")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("S")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("OMETHING")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("WASN")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("’")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("T")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("RIGHT")]), _vm._v(". Something besides the hot\n\t\t\t\t\tchocolate splashed across the cream-colored silk blouse and brown-linen slacks\n\t\t\t\t\tthat twenty-nine-year-old Emma Sanderson had come home to change.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pulling her key from the lock that Friday morning in early\n\t\t\t\t\tSeptember, she stood just inside the open front door of her two-story townhome,\n\t\t\t\t\tallowing the screen door to close behind her. She listened. But heard\n\t\t\t\t\tnothing.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Was Rob home?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She was in a hurry to get back to the high school before study\n\t\t\t\t\thall ended and twenty-two fifteen-year-olds converged on her American History\n\t\t\t\t\tclass. So she’d parked her car in the driveway and come in by way of the front\n\t\t\t\t\tporch, rather than through the garage as usual.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Was someone in the house? Rob Evert, her fiancé of two years,\n\t\t\t\t\twas attending an accounting seminar at a local college that morning. Besides,\n\t\t\t\t\tthe sweet citrusy smell in the air wasn’t something she associated with Rob.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("With her finger on the pepper-spray tube attached to her key\n\t\t\t\t\tchain, Emma moved forward a couple of steps. She should probably head right back\n\t\t\t\t\toutside. Call the police.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then she’d be late for class. She had to change.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And what criminal smelled like citrus?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There was no sign of forced entry.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Maybe, in the back of her mind, Emma knew she didn’t need\n\t\t\t\t\tlaw-enforcement protection. Because if she thought she did, she’d be outside and\n\t\t\t\t\ton the phone. Immediately. She wasn’t a risk-taker.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But then, she wasn’t going to let the past rob her of her\n\t\t\t\t\tpresent and future, either. Not anymore. Not since the phone calls she’d\n\t\t\t\t\treceived over the past month from a Comfort Cove detective, Ramsey Miller.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Miller’s news had upended her world. Frank Whittier, the man\n\t\t\t\t\tshe’d spent two years adoring and the next twenty-five years hating, was not\n\t\t\t\t\tguilty of abducting her baby sister. All this time she’d blamed him....")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Slipping out of her low-heeled pumps because she had to change\n\t\t\t\t\ther pants, Emma crept up the stairs. Someone could be up there.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Probably not. She was overreacting to the citrusy smell.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("her")]), _vm._v(" house. She wasn’t going\n\t\t\t\t\tto let paranoia run her out of the home she owned, the home shared with her\n\t\t\t\t\tfiancé.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Hugging the fall-foliage wallpaper—everything was fall for\n\t\t\t\t\tEmma, since the fall day Claire had disappeared—she listened as she rose slowly\n\t\t\t\t\tto the second floor.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Definite rustling sounds came from the upper region of her\n\t\t\t\t\thome. As if someone was moving around, but not opening drawers or closets. Or\n\t\t\t\t\tthrowing things.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her mother, who lived nearby, had a key, but Mom wouldn’t stop\n\t\t\t\t\tin without asking permission first. And, as the principal of a local school,\n\t\t\t\t\tRose Sanderson was at work.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The only other person who had a key, besides Emma, was Rob. And\n\t\t\t\t\the’d lied to her once before about his attendance at a seminar. He’d sworn he’d\n\t\t\t\t\tnever lie to her again. She’d believed him enough to let him move in with\n\t\t\t\t\ther.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But she didn’t fully trust him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her issue. One she was working on.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Their bedroom was the first door on the left. It had its own\n\t\t\t\t\tattached bath. The second bedroom and smaller bath were to the right.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She looked that way first. Surely the intruder wasn’t in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("her")]), _vm._v(" room.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("At the top of the stairs, Emma paused, flicking her long dark\n\t\t\t\t\tcurls back over her shoulder, suddenly questioning the wisdom of her actions.\n\t\t\t\t\tThe rustling was louder, but steady. A familiar rhythm. Clearly she hadn’t been\n\t\t\t\t\tdiscovered yet.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And then she heard the familiar moan. Short, staccato, deep in\n\t\t\t\t\tthe throat. Followed by a longer, louder, expression of relief. The moan she’d\n\t\t\t\t\tthought had been particular to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("her.")]), _vm._v(" The one only she\n\t\t\t\t\tcould elicit.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He was in their room. For a brief second, as she rounded the\n\t\t\t\t\tcorner toward the open door, Emma wondered if he was alone. Hoped he was.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("If so, she could slip away, pretend she hadn’t seen, and they\n\t\t\t\t\tcould continue to…")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The woman was on the bottom, her naked backside sinking into\n\t\t\t\t\tthe freshly laundered gold sheets Emma had just put on the queen-size bed that\n\t\t\t\t\tmorning. Blond hair splayed across Emma’s pillow.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, God.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The other woman was looking at her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("On another day, any day previous to the last phone call from\n\t\t\t\t\tRamsey Miller, Emma would have turned around and left Rob to get his mess\n\t\t\t\t\tcleaned up and out of their house.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And then, when enough time had passed to take away the sting of\n\t\t\t\t\this betrayal, she’d have listened patiently while he expressed his\n\t\t\t\t\tself-condemnation and regret. She’d have let him beg. And then she’d have taken\n\t\t\t\t\thim back.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("This wasn’t the first time he’d been unfaithful to her. But it\n\t\t\t\t\twas the first in their bed. In her home. The first since he’d put the huge\n\t\t\t\t\tdiamond ring on her finger.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("At least the first she knew of…")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Thoughts sped through Emma’s mind as she stood frozen and\n\t\t\t\t\twatched the slender long legs disentangle themselves from the man and the\n\t\t\t\t\tsheets.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rob rolled to his side and Emma pulled the ring off her left\n\t\t\t\t\thand. He noticed her standing there.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The instant consternation on his face couldn’t have been faked.\n\t\t\t\t\tNor could the sorrow in his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Emma, baby, I…”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ignoring the woman who was in Emma’s peripheral vision pulling\n\t\t\t\t\ton sweatpants and a T-shirt, Emma approached the bed and held out the ring to\n\t\t\t\t\tRob.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I see she dressed up for the occasion,” she said calmly, as if\n\t\t\t\t\tthey were discussing what color to paint the bedroom walls.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Emma, please…” Rob, looked at her pleadingly, holding the\n\t\t\t\t\tsheet around his naked midsection despite the fact that both women in the room\n\t\t\t\t\tclearly knew what the covered parts looked like. He didn’t reach for the ring.\n\t\t\t\t\tBut he’d expect it back. He was an accountant. Money mattered.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She placed the two-carat promise on the corner of the dresser.\n\t\t\t\t\tGrabbed a hanger out of the closet that held one of her three-piece suits—the\n\t\t\t\t\ttailored black slacks and jacket and red short-sleeved blouse—grabbed her most\n\t\t\t\t\texpensive black pumps and marched toward the door.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m going back to work,” she said, facing the open door,\n\t\t\t\t\teffectively blocking the blond woman’s escape. “I’ll go straight to Mom’s\n\t\t\t\t\tafterward, spend the night there and return here in the morning to meet a\n\t\t\t\t\tlocksmith who will be changing the locks.” She owned the place. She could do\n\t\t\t\t\tthis. “You have until then to clean out anything of yours you want to keep. The\n\t\t\t\t\tfurniture all stays. The payments you helped make are in lieu of rent for the\n\t\t\t\t\tpast two years.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She heard her voice and wondered at the woman speaking. She\n\t\t\t\t\tdidn’t recognize a thing about her. But, damn, her words felt good.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Emma…”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She heard scrambling behind her, a thump as Rob’s feet landed\n\t\t\t\t\ton the floor, and then his footsteps behind her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Emma!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Head high, she just kept walking. Down the stairs. Out the\n\t\t\t\t\tfront door. Knowing he couldn’t follow her. He hadn’t had time to pull on his\n\t\t\t\t\tpants.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("In a nearby gas-station bathroom, as she changed her clothes,\n\t\t\t\t\tEmma crumpled, half dressed, on the toilet. She started to cry. To panic. To\n\t\t\t\t\thurt.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But she didn’t go back.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And that afternoon, when she left school, she didn’t back\n\t\t\t\t\tdown.")]), _vm._v(" "), _c('p', {
    staticClass: "tb"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("T")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("HE")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("FUNERAL")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("WAS")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("SO")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("CROWDED")]), _vm._v(" that early September Friday\n\t\t\t\t\tafternoon that more than half the attendees had to stand. Forty-year-old Chris\n\t\t\t\t\tTalbot was one of those standing, holding his place in a back corner of the big\n\t\t\t\t\told Comfort Cove church with shoulders grown thick from a lifetime of\n\t\t\t\t\tlobstering. Fishing was a dangerous business. The most dangerous in the world if\n\t\t\t\t\tyou believed what you saw on television.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("To Chris it was a way of life. The only way of life.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It had been that way for Wayne Ainge, too, though Chris had\n\t\t\t\t\tbarely known the young man whose funeral he’d given up a day of work to attend.\n\t\t\t\t\tWayne was only twenty. He’d arrived in Comfort Cove from Alaska that summer. Had\n\t\t\t\t\tsigned on with one of Chris’s competitors. And three days ago he’d gotten his\n\t\t\t\t\tfoot tangled up in a trapline and was pulled from his boat to the bottom of the\n\t\t\t\t\tocean. He’d drowned before anyone could get to him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The accident had not been the boy’s fault. It hadn’t been\n\t\t\t\t\tanything he could prevent. A wind had come up, a wave, just as he’d been\n\t\t\t\t\thoisting a trap overboard, forcing him into one small step to keep his balance.\n\t\t\t\t\tThe one small step had cost him his life.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His wasn’t the first industry death, by a long shot.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But it was Comfort Cove’s first in more than fifty years. The\n\t\t\t\t\tfirst in Chris’s lifetime.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Wayne’s father spoke. His brother did, too. A man of the\n\t\t\t\t\tcloth—Chris wasn’t a churchgoing man so he wasn’t sure if the man was a priest\n\t\t\t\t\tor pastor or what—read from the Bible and asked them all to pray.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Chris bowed his head out of respect for Wayne’s family, who’d\n\t\t\t\t\tflown in from Alaska to bury their son where he’d said his heart was—the\n\t\t\t\t\tAtlantic Ocean. And then, as people began to file out, he shook hands with his\n\t\t\t\t\tfellow fishermen and their families.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("None of them looked one another in the eye.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Every fisherman knew that any one of them could be in that\n\t\t\t\t\tcasket up there. It was only by the grace of God that they made it safely home\n\t\t\t\t\teach day.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph-18"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49cc58eb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChapterOne.vue
// module id = 78
// module chunks = 0